import { useRef } from 'react'
import Contact from '../../assets/images/Photo/contact.png'
import Sharky from '../../assets/images/Photo/sharky.png'
import './About.css'
import { ReactComponent as CircleText } from '../../assets/images/Doodles/circleText.svg'
import SharkyWaving from '../../assets/images/Sharky/Sharky_Waving.png'
import gsap from 'gsap'
import { ScrollTrigger } from 'gsap/ScrollTrigger'
import { SplitText } from 'gsap/SplitText'
import { useTranslation, Trans } from 'react-i18next'
import { useGSAP } from '@gsap/react'
gsap.registerPlugin(ScrollTrigger)
gsap.registerPlugin(SplitText)

export default function AboutMobile() {
    const aboutDesktopRef = useRef();
    const { t, i18n } = useTranslation(['common', 'navigation']);
    
    useGSAP(() => {
        const ctx = gsap.context(() => {
            // Obtener todos los elementos con la clase
            const textElements = gsap.utils.toArray(".about-text-appear");
            
            textElements.forEach((element) => {
                // eslint-disable-next-line
                let split = SplitText.create(element, {
                    type: "lines",
                    autoSplit: true,
                    onSplit: (self) => {
                        return gsap.from(self.lines, {
                            scrollTrigger: {
                                trigger: element, // Cada elemento es su propio trigger
                                start: "top 75%",
                                end: "+=150",
                                scrub: true,
                                markers: false //only dev
                            },
                            y: 50,
                            autoAlpha: 0,
                            stagger: 0.05
                        });
                    }
                });  
            });
        });

    return () => ctx.revert(); // Limpieza automática
    }, {scope: aboutDesktopRef, dependencies: [i18n.language]});

    return (
        <div className='section-about bg-bluekali-navy-blue flex flex-col items-start justify-start pt-24 w-full overflow-hidden' id='section-about'>
            <div className="flex justify-between pl-6">
                <div className='flex flex-col justify-between w-7/12'>
                    <h1 className='text-3xl font-bold'>{t('about.title')}</h1>
                    <div className='text-sm mt-4'>
                        <Trans 
                            i18nKey="about.desc"
                            components={{ bold: <span className="font-bold"/> }} 
                        />
                    </div>
                    <h3 className='text-sm mt-6 about-text-appear'>{t('about.under_text')}</h3>
                </div>
                <img alt='' className=' w-4/12 object-cover rounded-l-xl custom-shadow' src={Contact}/> 
            </div>
            <div className='w-full mt-6 pl-6 pr-6'>
                <img alt='' className='w-full h-32 object-cover object-[center_73%] rounded-xl custom-shadow' src={Sharky}/> 

                <div className='flex flex-col justify-between'>
                    <h3 className='text-sm mt-6 font-black'>{t('about.mission_title')}</h3>
                    <h3 className='text-sm w-5/6 about-text-appear'>{t('about.mission')}</h3>
                </div>

                <div className='flex flex-col justify-between items-end'>
                    <h3 className='text-sm mt-6 font-black'>{t('about.vision_title')}</h3>
                    <h3 className='text-sm w-5/6 text-right about-text-appear'>{t('about.vision')}</h3>
                </div>

            </div>

            <div className='h-full w-full flex justify-center relative items-center mt-8 mb-10'>
                <CircleText className='w-3/4 spin-slow'/>
                <div className="absolute flex justify-center top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2">
                    <img src={SharkyWaving} alt='' className='w-2/4 scale-x-[-1] rotate-12'/>
                </div>
            </div>
        </div>
    );
}